/**
 * Nạp Google Maps JS (+ Places) đúng một lần cho cả app — dùng chung cho ô gợi ý địa chỉ
 * và bản đồ phiên đăng nhập. Chưa cấu hình khoá hoặc nạp lỗi → trả `null` để UI tự fallback.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GoogleNamespace = { maps: any };

const BROWSER_KEY = process.env.REACT_APP_GOOGLE_MAPS_BROWSER_KEY;

let loader: Promise<GoogleNamespace | null> | null = null;

export const hasGoogleMapsKey = (): boolean => Boolean(BROWSER_KEY);

export const loadGoogleMaps = (): Promise<GoogleNamespace | null> => {
  if (!BROWSER_KEY) return Promise.resolve(null);
  if (loader) return loader;

  loader = new Promise((resolve) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const existing = (window as any).google;
    if (existing?.maps?.places) {
      resolve(existing);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${BROWSER_KEY}&libraries=places&language=vi&region=VN`;
    script.async = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    script.onload = () => resolve((window as any).google ?? null);
    script.onerror = () => {
      // eslint-disable-next-line no-console
      console.warn('[googleMaps] Không nạp được Google Maps JS.');
      loader = null;
      resolve(null);
    };
    document.head.appendChild(script);
  });

  return loader;
};
